import { DataGridV2, IconButton } from '@celltrak/ui-components';

import { text } from '../../constants';

import useAgencyCredentialsGrid from './hooks';
import { credentialsHeaders } from './gridDefinitions';
import styles from './AgenciesCredentialsGrid.module.scss';

const AgenciesCredentialsGrid = () => {
  const {
    isLoading,
    credentials,
    handleColumnClick,
    sortByColumn,
    sortDirection,
    handleRowClick,
    handleCreateCredential,
  } = useAgencyCredentialsGrid();

  const renderCredentialsGrid = () => (
    <DataGridV2
      rows={credentials}
      headers={credentialsHeaders}
      onColumnClick={handleColumnClick}
      onRowClick={handleRowClick}
      sortByColumn={sortByColumn}
      sortDirection={sortDirection}
      stickyHeader
      loading={isLoading}
    />
  );

  return (
    <div className={styles.agenciesCredentialsTab}>
      <div className={styles.createButtonContainer}>
        <IconButton onClick={handleCreateCredential}>{text.createAgencyLabel}</IconButton>
      </div>
      <div className={styles.credentialsGrid}>{renderCredentialsGrid()}</div>
    </div>
  );
};

export default AgenciesCredentialsGrid;
